import { ReactNode } from 'react'

export const getPlainTextFromReactNode = (children: ReactNode): string => {
  if (Array.isArray(children)) {
    const textArray = children.map(getPlainTextFromReactNode)
    return textArray.join('')
  }
  if (typeof children === 'string') {
    return children
  }
  if (typeof children === 'object' && !!children && 'props' in children) {
    return getPlainTextFromReactNode(children.props.children)
  }
  return children ? String(children) : ''
}
